import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'prompt-library',
});

export const promptRouteRef = createSubRouteRef({
  id: 'prompt-library-prompt',
  parent: rootRouteRef,
  path: '/prompt/:id',
});

export const agentRouteRef = createSubRouteRef({
  id: 'prompt-library-agent',
  parent: rootRouteRef,
  path: '/agent/:id',
});
